import { buildApiUrl } from '@/utils/url/build-url';
import { getConfig } from '@/utils/config/config';

export const getLauncherOrigin = (): string => {
    const config = getConfig();
    const launcherUrl = buildApiUrl(config.apis.LauncherClient);

    if (config.sameOriginGameLauncher) {
        if (typeof window !== 'undefined') {
            return window.location.origin;
        }
        return new URL(config.domain).origin;
    }

    return new URL(launcherUrl).origin;
};

export const getLobbyOrigin = (): string => {
    if (typeof window !== 'undefined') {
        return window.location.origin;
    }
    return new URL(getConfig().domain).origin;
};

export const getAllowedGameMessageOrigins = (): Set<string> => new Set([getLobbyOrigin(), getLauncherOrigin()]);

export const isAllowedGameMessageOrigin = (origin: string): boolean =>
    Boolean(origin) && getAllowedGameMessageOrigins().has(origin);
